import { Create, Datagrid, Edit, ImageField, List, ReferenceField, ReferenceInput, SaveButton, SelectInput, SimpleForm, TextField, TextInput, Toolbar ,EditButton,DeleteButton} from "react-admin";
import UploadImage from '../shared/uploadImage';

export const SubCategoryList = (props) => {
    return (
        <List {...props}>
            <Datagrid rowClick="edit">
                <TextField source="id" />
                <TextField source="name" />
                <ReferenceField source="category_id" reference="Category">
                    <TextField source="name" />
                </ReferenceField>
                <ImageField source="image" />
                <EditButton></EditButton>
                          <DeleteButton mutationMode="pessimistic" />

               
            </Datagrid>
        </List>
    )
}

export const SubCategoryCreate = (props) => {

    return (
        <Create title="Create a Sub-Category "{...props} dir="rtl" redirect="list">
            <SimpleForm>
                <TextInput source="name" />
                <ReferenceInput source="category_id" reference="Category">
                    <SelectInput optionText="name" value="id" />
                </ReferenceInput>
                <UploadImage name="image" /> 
            </SimpleForm>
        </Create>
    )
}

const UserEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);


export const SubCategoryEdit = (props) => {
    return (<Edit {...props} >
        <SimpleForm toolbar={<UserEditToolbar />}>
            <TextInput source="name" />
            <UploadImage name="image" />
        </SimpleForm>
    </Edit>)
}


